// 数据包指令
export default {
	// 心跳检测
	HEART_BEAT_REQUEST: 10,

	// 登录
	LOGIN_REQUEST: 100,
	LOGIN_RESPONSE: 101,

	// 退出登录
	LOGOUT_REQUEST: 200,
	LOGOUT_RESPONSE: 201,

	// 消息
	MESSAGE_REQUEST: 300,
	MESSAGE_RESPONSE: 301,
	//结束会话
	CLOSE_SESSION_REQUEST:401,
	UPDATE_SERVICE_REQUEST: 501,
	// 消息已读
	MESSAGE_READ_REQUEST :601
};
